import React, { useMemo } from 'react';
import FeatureTable from './FeatureTable';

export default function FeaturesInfo({ features }) {
    const columns = useMemo(() => [{Header: "Category", accessor: "Category"}, {Header: "Features", accessor: "Feature"}], []);
    const data = useMemo(() => {
        return features;
    }, [features])
    return (
        <div className="ml-5 p-5 bg-white shadow">
            <FeatureTable columns={columns} data={data} />
        </div>
    )
}